import { Dialog, DialogContent, Box, DialogActions, FormHelperText, Button, IconButton, DialogTitle, Divider } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setMachineDetailsData } from '../../../redux/machineDetailsDataSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { cleanRichText } from '../../../utils/richText';
import RichTextEditor from '../../richText/RichTextEditor';
import useContentFormDialog from '../../richText/useContentFormDialog';
import '../../../css/users/addUserDialog.css';

export const ModifierModeEmploi = (props) => {

    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const machineDetailsData = useSelector((state) => state.MachineDetailsData);
    const dialogProps = useContentFormDialog();

    const { modifyModeEmploi, setModifyModeEmploi } = props;

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            Instructions_for_use: machineDetailsData?.Instructions_for_use || '',
        },
        validationSchema: Yup.object().shape({
            Instructions_for_use: Yup.string().nullable(),
        }),
        onSubmit: async (values) => {
            try {
                const cleanedContent = cleanRichText(values.Instructions_for_use);
                const response = await axios.patch(`machine/mode_emploi/${id}`, { Instructions_for_use: cleanedContent });
                if (response.status === 200 || response.status === 201) {
                    dispatch(setSuccessfullModifyDialog({ open: true, type: 'Modifier le mode d’emploi' }));
                    dispatch(setMachineDetailsData({ ...machineDetailsData, Instructions_for_use: response.data.Instructions_for_use }));
                    setModifyModeEmploi(false);
                }
            } catch (error) {
                console.error('Error updating machine status:', error);
                CustomErrorLogger(error, 'Error updating machine mode_emploi in ModifierModeEmploi');
            }
        },
    });

    const { handleSubmit, values, touched, errors, setFieldValue } = formik;

    const handleClose = () => setModifyModeEmploi(false);

    return (
        <Dialog open={modifyModeEmploi} {...dialogProps}>
            <IconButton onClick={handleClose} className='addUser_icon_button'>
                <Iconify icon={"material-symbols:close"} className='addUser_close_icon' />
            </IconButton>
            <DialogTitle className='addUser_dialog_title'>{t('Modifier le mode d’emploi')}</DialogTitle>
            <Divider />
            <form className='contentFormDialog_form' onSubmit={handleSubmit}>
                <DialogContent className='addUser_dialog_content contentFormDialog_content'>
                    <Box className="addUser_helper_selct_box contentFormDialog_description">
                        <FormHelperText className="addUserInputTitle">{t('Mode d’emploi')}</FormHelperText>
                        <RichTextEditor
                            value={values.Instructions_for_use}
                            onChange={(html) => setFieldValue('Instructions_for_use', html)}
                            placeholder={t('Mode d’emploi')}
                        />
                        {touched.Instructions_for_use && errors.Instructions_for_use && (
                            <FormHelperText error>{errors.Instructions_for_use}</FormHelperText>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions className='addUser_dialog_actions'>
                    <Button className='addUser_button_annuler' onClick={handleClose}>{t('Annuler')}</Button>
                    <Button className='addUser_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};
